export const sideBar = sideBar => ({
    type: 'GET_SIDEBAR',
    sideBar
  })


  